/**
 * LA CURVA DE PESO DEL CICLO: DESDE DÓNDE CUENTA Y A QUIÉN SE LE HABLA (14-10, QUI-02).
 *
 * `components/GraficaDePeso` la pintan dos pantallas: la Evolución del cliente y la ficha
 * del equipo. En la ficha salía «Todavía no te has pesado en este ciclo. Con dos pesajes te
 * dibujamos tu evolución», hablándole de tú al entrenador, y además con un pesaje hecho ese
 * mismo día. Eran dos cosas distintas:
 *
 *   1. A QUIÉN SE LE HABLA. Los textos salen de `textosDeLaCurva(ajeno)`: `ajeno` es que
 *      quien mira es el equipo y el peso es del cliente, igual que en `pesoValido.revisarPeso`.
 *   2. DESDE DÓNDE CUENTA EL CICLO. La curva por semanas trae un punto por semana, fechado
 *      en su LUNES, y el servidor ya la arranca en el lunes de la semana en que empieza el
 *      ciclo (`core/series_cliente.curva_semanal`). Aquí se cortaba por el instante exacto
 *      del arranque, así que a quien empieza un miércoles se le caía su primera semana
 *      entera: «no te has pesado en este ciclo» con el peso recién mandado. Con la curva
 *      semanal el corte es el lunes de esa semana (`corteDelCiclo`).
 */

/**
 * El instante desde el que un punto de la serie es «de este ciclo», o null si no hay
 * arranque que se entienda. `porSemanas`: la serie trae un punto por semana, en su lunes.
 */
export function corteDelCiclo(arranque, porSemanas = false) {
    if (!arranque) return null;
    const ts = new Date(arranque).getTime();
    if (!Number.isFinite(ts)) return null;
    if (!porSemanas) return ts;
    // Un día suelto («2026-10-14») es ese día del calendario, no la medianoche de UTC.
    const dia = typeof arranque === 'string' && arranque.length === 10
        ? new Date(`${arranque}T12:00:00`) : new Date(ts);
    dia.setHours(0, 0, 0, 0);
    dia.setDate(dia.getDate() - ((dia.getDay() + 6) % 7));     // su lunes
    return dia.getTime();
}

const AL_CLIENTE = {
    tuCurva: 'Tu curva',
    tuObjetivo: 'Tu objetivo',
    vasPor: 'Vas por',
    empezasteElCiclo: 'Empezaste el ciclo en',
    empezaste: 'Empezaste en',
    primerPesoDelCiclo: 'Tu primer peso del ciclo',
    primerPeso: 'Tu primer peso',
    sinPesoEnElCiclo: 'Todavía no te has pesado en este ciclo.',
    elDeAntes: 'Tu último peso es de antes de este ciclo',
    desdeQueEntraste: 'Desde que entraste',
    cuandoEntraste: 'Cuando entraste pesabas',
    llevas: 'Llevas',
    llevasDesde: 'Llevas con nosotros desde',
};

const AL_EQUIPO = {
    tuCurva: 'Su curva',
    tuObjetivo: 'Su objetivo',
    vasPor: 'Va por',
    empezasteElCiclo: 'Empezó el ciclo en',
    empezaste: 'Empezó en',
    primerPesoDelCiclo: 'Su primer peso del ciclo',
    primerPeso: 'Su primer peso',
    sinPesoEnElCiclo: 'Todavía no se ha pesado en este ciclo.',
    elDeAntes: 'Su último peso es de antes de este ciclo',
    desdeQueEntraste: 'Desde que entró',
    cuandoEntraste: 'Cuando entró pesaba',
    llevas: 'Lleva',
    llevasDesde: 'Lleva con nosotros desde',
};

/** Los textos de la gráfica: de tú al cliente; del cliente, en tercera persona, al equipo. */
export const textosDeLaCurva = (ajeno = false) => (ajeno ? AL_EQUIPO : AL_CLIENTE);
